import React from "react";
import { Outlet } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { TopNav } from "./TopNav";
import { StewardStrip } from "./StewardStrip";
import { Footer } from "./Footer";

/**
 * Organization + WebSite JSON-LD are baked into index.html at build time
 * (see scripts/inject-seo.mjs) so non-JS crawlers see them on first byte.
 * Per-page JSON-LD (Article, Breadcrumb, FAQ, DonateAction) continues to
 * render via react-helmet-async on the page where it applies.
 */
export function MainLayout() {
  return (
    <HelmetProvider>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[100] focus:bg-ink focus:text-paper focus:px-4 focus:py-2 focus:text-xs focus:font-mono focus:uppercase focus:tracking-widest"
      >
        Skip to main content
      </a>
      <div className="min-h-screen flex flex-col font-sans text-ink bg-paper selection:bg-ember/20">
        <StewardStrip />
        <TopNav />
        <main id="main" className="flex-1 flex flex-col w-full">
          <Outlet />
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}
